import { TableData } from '@ddt-web/data-service';

/**
 * @description BoxPlotDataUtil: contains util methods for box plot chart specific data transformation.
 */
export class BoxPlotDataUtil {

	/**
	 * @description getDataByPercentileAttribute: transforms table data to box plot series data based on percentile attribute.
	 * @param {TableData} data: the table data to be transformed.
	 * @param {number} selectedPortfolioIndex: the index of the selected portfolio.
	 * @return {Array<number} represents the box plot chart series data.
	 */
	public static getDataByPercentileAttribute(data: TableData, selectedPortfolioIndex: number): Array<number> {
		const boxPlotSeriesData = [];
		try {
			data.cells[selectedPortfolioIndex].forEach(cell => {
				if (cell.config.label.attributes['isPercentile']) {
					boxPlotSeriesData.push(cell.rawValue);

				}
			});
		} catch (error) {
			console.error(`getDataByPercentileAttribute; failed to get series data`, error);
		}
		return boxPlotSeriesData;
	}
}
